import { render, staticRenderFns } from "./themeHoliday.vue?vue&type=template&id=0acfac11&scoped=true&"
import script from "./themeHoliday.vue?vue&type=script&lang=js&"
export * from "./themeHoliday.vue?vue&type=script&lang=js&"
import style0 from "./themeHoliday.vue?vue&type=style&index=0&id=0acfac11&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfac11",
  null
  
)

export default component.exports